import { Link } from "react-router-dom";
import { newsSorted } from "../lib/news";
import Reveal from "./Reveal";

function fmt(d) {
  return new Date(d + "T00:00:00").toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" });
}

// Homepage News preview.
// White background · black primary text · yellow/gold accents.
// Every card image uses `object-cover` inside a fixed aspect-ratio container so
// nothing is stretched or distorted; per-story object-position keeps the subject
// centered even on the tightest 4:5 crop.
export default function NewsPreview() {
  const items = newsSorted().slice(0, 3);
  return (
    <section
      id="news-preview"
      data-testid="news-preview"
      className="relative bg-white text-black py-20 md:py-28"
    >
      <div className="px-4 md:px-10 max-w-[1400px] mx-auto">
        <div className="flex items-end justify-between mb-8 md:mb-10 border-b border-[#B48A00]/40 pb-6">
          <div>
            <div className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#B48A00] mb-2">Latest</div>
            <h2 className="font-wide uppercase text-black text-4xl sm:text-5xl md:text-6xl">News</h2>
          </div>
          <Link
            to="/news"
            data-testid="news-read-all"
            className="font-mono text-[10px] tracking-[0.3em] uppercase text-black hover:text-[#B48A00] transition-colors"
          >
            Read All →
          </Link>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {items.map((n, i) => (
            <Reveal key={n.slug} delayMs={i * 90}>
              <Link
                to={`/news/${n.slug}`}
                data-testid={`news-card-${n.slug}`}
                className="group block"
              >
              <div className={`relative ${n.heroAspect || "aspect-[4/5]"} bg-neutral-100 overflow-hidden`}>
                <img
                  src={n.hero}
                  alt=""
                  loading="lazy"
                  data-testid={`news-card-image-${n.slug}`}
                  style={{ objectPosition: n.heroPosition || "center 30%" }}
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                {/* NEW badge — identical, top-right of every homepage News card image. */}
                <span
                  data-testid={`news-card-new-badge-${n.slug}`}
                  className="absolute top-3 right-3 bg-[#F4C10A] text-black font-mono uppercase tracking-[0.24em] text-[10px] leading-none px-2.5 py-1.5 shadow-sm select-none"
                >
                  New
                </span>
              </div>
              <div className="mt-4">
                <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#B48A00]">
                  {fmt(n.date)}
                </div>
                <h3 className="mt-2 font-wide uppercase text-black text-lg md:text-xl leading-tight group-hover:text-[#B48A00] transition-colors">
                  {n.title}
                </h3>
                <p className="mt-2 font-body text-black/80 text-sm leading-relaxed line-clamp-3">
                  {n.excerpt}
                </p>
                <div className="mt-3 font-mono text-[10px] tracking-[0.3em] uppercase text-[#B48A00]">
                  Read More →
                </div>
              </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
